import { type ReactNode } from 'react';
import { View, StyleSheet, StyleProp, ViewStyle } from 'react-native';

export interface TableRowProps {
  onHoverChange?: (isHovered: boolean) => void;
  style?: StyleProp<ViewStyle>;
  height?: number;
  columnGap?: number;
  children?: ReactNode;
  isHeader?: boolean;
}

export function TableRow({ onHoverChange, style, height, columnGap = 0, children, isHeader = false }: TableRowProps) {
  const handleMouseEnter = () => {
    onHoverChange?.(true);
  };

  const handleMouseLeave = () => {
    onHoverChange?.(false);
  };

  return (
    <View
      style={[styles.row, isHeader && styles.headerRow, { height, gap: columnGap }, style]}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  headerRow: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
});
